<app-header *ngIf="!isAdminRoute && !isMaintenanceRoute"></app-header>
<main>
  <router-outlet></router-outlet>
</main>
<app-footer *ngIf="!isAdminRoute && !isMaintenanceRoute"></app-footer>
